class ProductsViewer {

	constructor(){  
    this.component = document.querySelector('[data-component="products-viewer"]');
    
    if(this.component){
      this.triggers         = this.component.querySelectorAll('[data-trigger="products-viewer"]');
      this.mainImageElement = this.component.querySelector('[data-target="products-viewer-image"]');
      this.mainTitleElement = this.component.querySelector('[data-target="products-viewer-title"]');
      this.mainImage        = this.mainImageElement.getAttribute('src');
      this.mainTitle        = this.mainTitleElement.innerHTML;
      this._init();
    }
	}

	_init(){
    for (let element of this.triggers) {
      element.addEventListener('click', (event)=> this._updateMainProduct(event, element) );
      element.addEventListener('mouseover', (event)=> this._updateMainProduct(event, element) );
      element.addEventListener('mouseout', (event)=> this._restoreMainProduct(event) );
    }
  }
  
  _updateMainProduct(event, element){
    const title = element.getAttribute('data-title');
    const image = element.getAttribute('data-image');
    
    this.mainImageElement.setAttribute('src', image);
    this.mainTitleElement.innerHTML = title;

    if(event.type === 'click'){
      this.mainImage = image;
      this.mainTitle = title;
    }
  }
  
  _restoreMainProduct(event){
    this.mainImageElement.setAttribute('src', this.mainImage);
    this.mainTitleElement.innerHTML = this.mainTitle;
  }
}

export const productsViewer = new ProductsViewer();